import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.667 11.5a2.325 2.325 0 0 1-1.684-.732A2.565 2.565 0 0 1 9.286 9c0-.663.25-1.299.697-1.768a2.325 2.325 0 0 1 1.684-.732c.631 0 1.237.263 1.683.732.447.47.698 1.105.698 1.768 0 .328-.062.653-.182.957-.12.303-.295.579-.516.81a2.377 2.377 0 0 1-.772.543c-.29.125-.599.19-.911.19Zm0-9.5c-1.768 0-3.464.737-4.714 2.05C5.703 5.363 5 7.143 5 9c0 5.25 6.667 13 6.667 13s6.666-7.75 6.666-13c0-1.857-.702-3.637-1.952-4.95C15.13 2.737 13.435 2 11.667 2Z",
		fill: "currentColor"
	})
});
export default SvgLocation;
